import { rem, rgba } from 'polished';
import styled, { css } from 'styled-components';

import { IStyledReferralCardMainInfoStatusProps } from './ReferralCard.types';
import { EReferralStatus } from '../../../types';

export const StyledReferralCard = styled.div`
  border-radius: ${rem('16px')};
  padding: ${rem('8px')};

  ${({ theme }) => css`
    box-shadow: 0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)};
  `};

  min-width: ${rem('160px')};

  & * {
    padding: 0;
    margin: 0;
  }
`;

export const StyledReferralCardMainInfo = styled.div`
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  border-radius: ${rem('12px')};
  padding: ${rem('16px')} ${rem('8px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem('12px')};
`;

export const StyledReferralCardMainInfoUsername = styled.div`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 700;
  text-align: center;
`;

export const StyledReferralCardMainInfoStatus = styled.p<IStyledReferralCardMainInfoStatusProps>`
  background-color: ${({ theme, status }) => {
    if (status === EReferralStatus.New) return theme.colors.cross.silverFox;
    if (status === EReferralStatus.OnHold) return theme.colors.cross.brightSun;
    if (status === EReferralStatus.Accepted)
      return theme.colors.cross.greenMint;
    if (status === EReferralStatus.Rejected) return theme.colors.cross.red;
    if (status === EReferralStatus.Published) return theme.colors.cross.arancin;
    if (status === EReferralStatus.Rented) return theme.colors.cross.deepBlu;
  }};
  color: ${({ theme }) => theme.colors.main};
  padding: ${rem('2px')} ${rem('12px')};
  border-radius: ${rem('20px')};
  font-size: ${rem('14px')};
  font-weight: 700;
`;

export const StyledReferralCardMainInfoDate = styled.p`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('14px')};
`;

export const StyledReferralCardCityInfo = styled.dl`
  padding: ${rem('16px')} ${rem('8px')} ${rem('8px')};
  display: flex;
  justify-content: space-between;
`;

export const StyledReferralCardCityInfoTitle = styled.dt`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
`;

export const StyledReferralCardCityInfoDescription = styled.dt`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('16px')};
  font-weight: 700;
`;
